// src/components/common/PartnerSkeleton.tsx

export function PartnerSkeleton() {
    return (
        <div className="relative overflow-hidden bg-gray-200 rounded-lg h-12 w-36">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
        </div>
    );
}